// ── "Other fixes nobody has confirmed yet that may go out with it: N" (live check 2026-11-04) ─────────────────────────
// The server lists the unconfirmed fixes on test that may not be on every other system yet (GET /api/bugify/release
// `riding_items`; the rule is server/src/services/bugifyRelease.ts ridingItems). The Confirm question is about ONE
// report, so it leaves that report out — and any report that shares its fix commit, since one change covering several
// reports is one fix, not "another" one. Pure (no React, no API client): the server's test suite requires it as it is.

export interface RidingItem { id: string; commit: string }

/** Two abbreviations of one commit (7+ hex characters, one a prefix of the other) — the server's sameSha. */
export const sameCommit = (a: string, b: string): boolean =>
  !!a && !!b && a.length >= 7 && b.length >= 7 && (a.startsWith(b) || b.startsWith(a));

/** How many OTHER unconfirmed fixes go out with the report `itemId` (fix commit `itemCommit`). A server that sends no
 *  list (one older than this rule) yields 0: saying nothing beats repeating the number that counted the report itself. */
export function ridingOthers(info: { riding?: number; riding_items?: RidingItem[] } | null | undefined, itemId: string, itemCommit: string): number {
  const list = info && Array.isArray(info.riding_items) ? info.riding_items : null;
  if (!list) return 0;
  const total = Math.max(list.length, Number(info?.riding) || 0);   // the list is capped at 200; the count is not
  const mine = list.filter(r => !!r && (r.id === itemId || sameCommit(String(r.commit || ''), itemCommit || ''))).length;
  return Math.max(0, total - mine);
}
